<ng-container *ngIf="apps?.length">
  <button mat-icon-button [matMenuTriggerFor]="keepsMenu" class="user-button h-[56px] sm:h-[64px]">
    <div class="flex flex-row justify-center items-center">
      <mat-icon>apps</mat-icon>
    </div>
  </button>
</ng-container>

<mat-menu #keepsMenu="matMenu" [overlapTrigger]="false" xPosition="before">
  <a
    mat-menu-item
    *ngFor="let app of apps"
    [href]="getAppHref(app)"
    target="_blank"
    class="no-underline font-semibold"
    rel="noopener"
  >
    <mat-icon>{{ app.icon }}</mat-icon>
    {{ app?.name }}
  </a>
</mat-menu>
